<template>
    <div class="question-input">
        <div class="form-group">
            <label for="ai-question-input" class="sr-only">Your Question</label>
            <input
                id="ai-question-input"
                ref="input"
                v-model="localValue"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': hasError }"
                placeholder="What would you like to know about this event?"
                :maxlength="characterLimit"
                :disabled="isLoading"
                @keydown.enter.ctrl="submitQuestion"
                @keydown.enter.meta="submitQuestion"
                @keydown.enter="submitQuestion"
                @input="$emit('input', $event.target.value)"
                aria-describedby="question-help question-error"
            />

            <!-- Help Text and Character Counter -->
            <div class="d-flex justify-content-between align-items-center mt-1">
                <small id="question-help" class="form-text text-muted">
                    Press <kbd>Enter</kbd> to submit
                </small>
                <small
                    class="text-muted"
                    :class="{ 'text-warning': isNearLimit, 'text-danger': isAtLimit }"
                >
                    {{ characterCount }}/{{ characterLimit }} characters
                    <span v-if="characterCount < 5" class="text-info">
                        (min. 5 characters)
                    </span>
                </small>
            </div>

            <!-- Error Message -->
            <div v-if="error" id="question-error" class="invalid-feedback d-block">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuestionInput',

    props: {
        value: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        characterLimit: {
            type: Number,
            default: 500
        },
        error: {
            type: String,
            default: ''
        }
    },

    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },

        characterCount() {
            return this.value.length
        },

        isNearLimit() {
            return this.characterCount > this.characterLimit * 0.8
        },

        isAtLimit() {
            return this.characterCount >= this.characterLimit
        },

        hasError() {
            return !!this.error
        },

        canSubmit() {
            return !this.isLoading &&
                   this.characterCount >= 5 &&
                   this.characterCount <= this.characterLimit &&
                   this.value.trim().length >= 5
        }
    },

    mounted() {
        // Auto-focus on the input when component mounts
        this.$nextTick(() => {
            if (this.$refs.input) {
                this.$refs.input.focus()
            }
        })
    },

    methods: {
        submitQuestion() {
            if (this.canSubmit) {
                this.$emit('submit')
            }
        }
    }
}
</script>

<style scoped>
.question-input {
    /* Component styling */
}

.character-counter {
    text-align: right;
}

.form-control:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-primary {
    min-width: 100px;
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 576px) {
    .d-flex {
        flex-direction: column;
        align-items: stretch;
    }

    .btn-primary {
        margin-top: 0.5rem;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AiAgents/FaqAgent/components/QuestionInput.vue